module.exports = __webpack_public_path__ + "img/logo_glarus_blue.051ff8a8.png";